// 专案组统计
export const dpgOption = {
  // 柱子颜色
  color: ['#5c7bd9'],

  // 鼠标移到柱子上时的触发的信息提示框
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow', // 鼠标移到柱子上时'坐标轴指示器'类型
    },
  },

  // 图表和父容器的距离(相当于 margin)
  grid: {
    top: '40px',
    bottom: 0,
    left: 0,
    right: 0,
    containLabel: true,
  },

  // '暂无数据'图层
  graphic: {
    type: 'text',       // 类型：文本
    left: 'center',
    top: 'middle',
    silent: true,       // 不响应事件
    invisible: true,    // 默认隐藏图层
    style: {
      fill: '#9d9d9d',
      fontWeight: 'bold',
      text: '暂无数据',
      fontFamily: 'Microsoft YaHei',
      fontSize: '16px',
    },
  },

  // x轴
  xAxis: [{
    type: 'category',
    axisLine: {
      show: false,                      // 隐藏轴线
      lineStyle: { color: '#999' },     // 轴线颜色
    },
    axisTick: {
      show: false,                      // 隐藏轴线上的刻度线(尺子上的竖线)
    },
    axisLabel: {
      color: '#000',                    // 轴文字颜色(默认跟轴线颜色一样)
    },
  }],

  // y轴
  yAxis: [
    {
      type: 'value',
      name: '专案组总数量',                 // 轴上方显示的名称
      nameTextStyle: {
        padding: [0, 0, 0, 40],
      },
      min: 0,
      minInterval: 1,                     // 使y轴刻度为整数
      splitLine: {
        lineStyle: { color: '#f4f4f4' },  // 网格线颜色
      },
      axisLine: {
        show: false,                      // 隐藏轴线
        lineStyle: { color: '#999' },     // 轴线颜色
      },
      axisTick: {
        show: false,                      // 隐藏轴线上的刻度线
      },
      axisLabel: {
        color: '#000',                    // 轴文字颜色(默认跟轴线颜色一样)
      },
    },
  ],

  series: [
    {
      type: 'bar',
      name: '专案组统计',
    },
  ],
};

// 样板间统计
export const roomOption = {
  // 柱子颜色
  color: ['#91cc75'],

  // 鼠标移到柱子上时的触发的信息提示框
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow', // 鼠标移到柱子上时'坐标轴指示器'类型
    },
  },

  // 图表和父容器的距离(相当于 margin)
  grid: {
    top: '40px',
    bottom: 0,
    left: 0,
    right: 0,
    containLabel: true,
  },

  // 暂无数据图层
  graphic: {
    type: 'text',       // 类型：文本
    left: 'center',
    top: 'middle',
    silent: true,       // 不响应事件
    invisible: true,    // 默认隐藏图层
    style: {
      fill: '#9d9d9d',
      fontWeight: 'bold',
      text: '暂无数据',
      fontFamily: 'Microsoft YaHei',
      fontSize: '16px',
    },
  },

  // x轴
  xAxis: [{
    type: 'category',
    axisLine: {
      show: false,                      // 隐藏轴线
      lineStyle: { color: '#999' },     // 轴线颜色
    },
    axisTick: {
      show: false,                      // 隐藏轴线上的刻度线(尺子上的竖线)
    },
    axisLabel: {
      color: '#000',                    // 轴文字颜色(默认跟轴线颜色一样)
    },
  }],

  // y轴
  yAxis: [
    {
      type: 'value',
      name: '样板间总数量',                 // 轴上方显示的名称
      nameTextStyle: {
        padding: [0, 0, 0, 40],
      },
      min: 0,
      minInterval: 1,                     // 使y轴刻度为整数
      splitLine: {
        lineStyle: { color: '#f4f4f4' },  // 网格线颜色
      },
      axisLine: {
        show: false,                      // 隐藏轴线
        lineStyle: { color: '#999' },     // 轴线颜色
      },
      axisTick: {
        show: false,                      // 隐藏轴线上的刻度线
      },
      axisLabel: {
        color: '#000',                    // 轴文字颜色(默认跟轴线颜色一样)
      },
    },
  ],

  series: [
    {
      type: 'bar',
      name: '样板间统计',
    },
  ],
};
